// extracted by mini-css-extract-plugin
export default {"iconHelp":"styles_iconHelp__822EZ","collapse":"styles_collapse__fMHR9"};